import React, { useState } from "react";
import { Button, Modal, Input, Checkbox, Tooltip } from "antd";
import { SafetyOutlined } from "@ant-design/icons";
import { types as at, errorAction } from "@authzsvc/api-lib";
import { enableOrDisableGroup, selectGroupById } from "../../actions/api";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { showErrorNotification, showSuccessNotification } from "../../util";
const { TextArea } = Input;

const BlockGroupButton = ({ canManage }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedGroup = useSelector((state) => state.groups.selectedGroup);

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState("");
  const [securityIssues, setSecurityIssues] = useState(false);

  const handleRefresh = async () => {
    const result = await dispatch(selectGroupById(id));
    if (result.type === errorAction(at.GET_GROUP_BY_ID)) {
      navigate(`/`);

      showErrorNotification(
        result?.payload?.title || "Failed to find group",
        result?.payload?.data?.message || "Sorry, something went wrong"
      );
    }
  };

  const handleBlockGroup = async () => {
    setLoading(true);
    const action = selectedGroup.disabled ? "enable" : "disable";
    const result = await dispatch(
      enableOrDisableGroup(
        selectedGroup.id,
        !selectedGroup.disabled,
        reason,
        securityIssues
      )
    );
    if (result.type === errorAction(at.POST_ENABLE_OR_DISABLE_GROUP)) {
      showErrorNotification(
        result?.payload?.title || "Failed to update group",
        result?.payload?.data?.message || "Sorry, something went wrong"
      );
    } else {
      showSuccessNotification(`Group ${action}d successfully`, "");

      handleRefresh();
    }
    setLoading(false);
    setShowModal(false);
  };

  return (
    <>
      <Tooltip
        title={
          selectedGroup?.securityIssues === true
            ? "Only the Security Team can enable this group, please raise a support ticket"
            : ""
        }
      >
        <Button
          id="blockGroupButton"
          style={{ backgroundColor: "#000" }}
          icon={<SafetyOutlined />}
          type="primary"
          onClick={() => setShowModal(true)}
          disabled={selectedGroup?.securityIssues || !canManage}
        >
          {selectedGroup.disabled ? "Enable" : "Block"}
        </Button>
      </Tooltip>
      <Modal
        title={selectedGroup.disabled ? "Enable Group" : "Block Group"}
        open={showModal}
        onOk={handleBlockGroup}
        onCancel={() => setShowModal(false)}
        okText={selectedGroup.disabled ? "Enable" : "Block"}
        okButtonProps={{
          danger: !selectedGroup.disabled,
          loading: loading,
          disabled: reason.trim().length === 0,
        }}
        cancelButtonProps={{ disabled: loading }}
      >
        <TextArea
          rows={2}
          placeholder="Reason"
          disabled={loading}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />

        <Tooltip title="">
          <Checkbox
            disabled={loading}
            checked={securityIssues}
            onChange={(e) => setSecurityIssues(e.target.checked)}
            style={{ marginTop: 8 }}
          >
            <b></b>Security Issues
          </Checkbox>
        </Tooltip>
        <p>
          Marking this group as having security issues will require intervention
          from the Security Team to re-enable it.{" "}
          <b>
            Are you sure you want to{" "}
            {selectedGroup.disabled ? "enable" : "block"} this group?
          </b>
        </p>
      </Modal>
    </>
  );
};

export default BlockGroupButton;
